// PPC Constants
export const REGEX_TIERS_NAMES = ['BASE', 'TOL', 'UNL'];
export const LOYALTY_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
};
export const LOYALTY_DETAILS_LINK = 'https://www.bloomingdales.com/customer-service/articles/bloomingdales-loyallist-program-terms-and-conditions';
